import styled, { useTheme } from 'styled-components'

import { getHistoryMetricsConfig } from './utils'

interface Props {
  valueKeys: string[]
  hiddenKeys: string[]
  onClick: (key: string) => void
  xSymbol: string
  ySymbol: string
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  margin-bottom: 8px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: 12px;
  }
`

const LegendItem = styled.span<{ $color: string; $cursor: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  color: ${p => p.$color};
  cursor: ${p => p.$cursor};
`

const SelectedCircle = styled.span<{ $backgroundColor: string; $border: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${p => p.$backgroundColor};
  border: ${p => p.$border};
`

export const LegendContent = ({ valueKeys, hiddenKeys, onClick, xSymbol, ySymbol }: Props) => {
  const theme = useTheme()
  const visibleKeys = valueKeys.filter(key => !hiddenKeys.includes(key))

  return (
    <Container>
      {valueKeys.map(key => {
        const config = getHistoryMetricsConfig(theme, xSymbol, ySymbol)[key]
        const isHidden = hiddenKeys.includes(key)
        const color = config?.stroke ?? theme.colors.text.primary
        const isEnabledLegendClick = visibleKeys.length > 1 || (visibleKeys.length === 1 && visibleKeys[0] !== key)

        return (
          <LegendItem
            key={key}
            $color={color}
            $cursor={isEnabledLegendClick ? 'pointer' : 'auto'}
            onClick={() => {
              if (isEnabledLegendClick) {
                onClick(key)
              }
            }}
          >
            <SelectedCircle
              $backgroundColor={isHidden ? 'transparent' : color}
              $border={isHidden ? `1px solid ${color}` : 'transparent'}
            />
            {config?.label ?? key}
          </LegendItem>
        )
      })}
    </Container>
  )
}
